import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';



declare var $: any;
declare var kendo: any;

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent implements OnInit {
  public checked = true;
  title = 'Registration-Portal';
  responseOutput = 'Please enter your credentials.';
  currentTab="";
  guid="";
  validateEmailIcon=false;
  enableUpdateButn=false;
  emailOk=false;

  showSpinner=false;
  showSpinnerUser=false;
  timer = null;
  cardWidth=100;
  showNavigationButton=false;

    user: InternalUserModel={
    _agentId:"",
    _agentGuid:"",
    _username:"",
    _email:"",
    _emailTwo:"",
    _phone:"",
    _phone2:"",
    _agentName :"",
    _password :"",
    _confPassword :"",
    _AgentAddress1 :"",
    _AgentAddress2 :"",
    _AgentAddress3 :"",
    _AgentAddress4 :"",
    _AgentAddress5 :"",
    _fax:"",
    _business:"",
    _contact:"",
  }

  public usernameAllowance = {
    title: 'Username Allows only',
    item1:'Alphanumeric characters [a – z] or uppercase [A – Z]',
    item2:'Digits [0 – 9] and underscores (_). Min 8 chars long.',
  };
  public passwordRequirements = {
  title: 'Password Requirements',
  item1:'At least 8 characters. A mixture of both uppercase and lowercase letters.',
  item2:'A mixture of letters and numbers. Include at least one special character.'
  };
  

  constructor(public _authService:AuthService, private router: Router, private notificationService: Notification_Service, private activatedRoute: ActivatedRoute) {
    // String.prototype.matchAll()
   }

  ngOnInit() {
    this._authService.selectedUser.subscribe(x=>{
      // if(x){ this was previously presetting the values.
      //   this.user =x;
      //   this.user._agentName = x._agentName;
      // }
    });

    $(document).ready(function () {
      $("#authentication-wrapper").hover(function () {
        kendo.fx($("#authentication-wrapper")).zoom("in").startValue(1).endValue(1.05).play();
      }, () => {
        kendo.fx($("#authentication-wrapper")).zoom("out").endValue(1).startValue(1.05).play();
      });
    })
    this.activatedRoute.params.subscribe(params => {
      this.guid = params['id']; //Value passed in the URL should be a GUID
      if(this.guid)this._authService.ValidateRecoveryGuid(this.guid)
   });
  }

  sendRecoveryEmail() {
   this.showSpinner =true
   this._authService.sendRecoveryEmail(this.user).subscribe((res:any) => {
     this.showSpinner =false;
     this.showNavigationButton= true;
     this.notificationService.successNotif("A recovery email was sent to (" + this.user._email + 
     ") successfuly. Go to your email account and follow the reuired steps to recover the account.", false);
    },
    error =>{
      this.showSpinner =false;
      if(error.error==='ANF'){
        this.notificationService.errorNotif("We did not find an agent with email: (" + this.user._email + 
        ").");
      }
      else{
        this.notificationService.errorNotif(error.message);
      }
    });
  }
  

  enteredEmail(value:string){// Username on input
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(re.test(String(value).toLowerCase())) 
      this.validateEmailIcon=true;
    else 
      this.validateEmailIcon=false;
  }

  navigateToLogin(){
    this.router.navigateByUrl('/sign-in');
  }

  checkPassword(){  //implement service for error message
    //     r'^
    //   (?=.*?[A-Z])         // should contain at least one upper case
    //   (?=.*?[a-z])         // should contain at least one lower case
    //   (?=.*?[0-9])         // should contain at least one digit
    //   (?=.*?[#?!@$%^&*-_]) // should contain at least one Special character
    //   .{8,}                // Must be at least 8 characters in length  
    // $
    if(  this.user._password=== this.user._confPassword 
         && new RegExp(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$`).test(this.user._password)){
      this.enableUpdateButn =true;
    }
    else{
      this.enableUpdateButn =false;
    }
  }

  UpdatePassword(){
    this._authService.UpdatePassword(this.user._password).subscribe(data =>{
      this.notificationService.successNotif("Your password was Successfully Updated.", false);
      this.showNavigationButton= true;
    }, error=>{
      this.notificationService.errorNotif("We were unable to update your password, please contact the  system Admin.");
    })
  }
}
